import { ADDON_PRODUCT_STORAGE_TYPES } from "@stores/addons/constants";
import { METER_PRODUCT_ANALYTICS_EVENTS_KEY } from "@stores/subscriptions/constants";
import { ManageCard } from "./ManageCard";
import { meteredLineItem } from "../utils";
import { anyOf, IAddOnContext, IMeteredAddOnDescriptor } from "../types";

const productAnalyticsFree = {
  productType: "product-analytics-free",
  kind: "metered",
  title: "Metabase Track",

  isVisible: ({ subscribed, isCloudHosted }) => isCloudHosted && !!subscribed,
  requires: anyOf(ADDON_PRODUCT_STORAGE_TYPES),

  // reports under the same meter as the paid variant, but with no allowance to
  // draw down there is nothing to split and nothing to bill
  // must stay gated on the subscription, not on the meter: both Track variants
  // report under the same meter key, so the key alone cannot say whose it is
  getUsage: ({ purchase, subscribed }: IAddOnContext) => {
    if (!subscribed) {
      return undefined;
    }

    const meter = purchase.meters?.[METER_PRODUCT_ANALYTICS_EVENTS_KEY];

    return {
      hasQuota: typeof meter?.meter_value === "number",
      usage: meter?.meter_value ?? 0,
      includedUnits: 0,
      includedUnitsUsed: 0,
      billableUnits: 0,
    };
  },

  // no Stripe price and no allowance to draw down; never the paid fallback rate
  getPricePerUnit: () => 0,
  getIncludedUnits: () => 0,

  getBillingRowItem: () => ({ detail: "Included" }),

  // the grant reports under the paid meter but prices every event at 0
  getPurchaseLineItem: (ctx) => meteredLineItem(ctx, "ingested events"),

  ManageCard,
} satisfies IMeteredAddOnDescriptor;

export default productAnalyticsFree;
